import { APIClient } from "./axiosClient";

export class JobApi {
  static fetchFxRatesAndUpdateInDB() {
    return APIClient("/fx/fetchFxRatesAndUpdateInDB");
  }

  static fetchFxRateJobHistory(payload: {
    jobName: string;
    startTime: string | null;
    endTime: string | null;
    pageNumber: number;
    pageSize: number;
    sortBy: string;
    sortOrder: string;
  }) {
    return APIClient("/jobs/job-execution-history", payload, { requestType: 'post' });
  }

  static generateTransferPartnerInvoice(transferPartnerCode: string, invoicePeriodMonth: string, invoicePeriodYear: string) {
    return APIClient(`/invoice/generateTransferPartnerInvoice?transferPartnerCode=${transferPartnerCode}&invoicePeriodMonth=${invoicePeriodMonth}&invoicePeriodYear=${invoicePeriodYear}`);
  }

  static generateClientInvoice(clientId: string, invoicePeriodMonth: string, invoicePeriodYear: string) {
    return APIClient(`/invoice/generateInvoiceForClient?clientId=${clientId}&invoicePeriodMonth=${invoicePeriodMonth}&invoicePeriodYear=${invoicePeriodYear}`);
  }

  static generateProgramInvoice(programCode: string, invoicePeriodMonth: string, invoicePeriodYear: string) {
    return APIClient(`/invoice/generateProgramInvoice?programCode=${programCode}&invoicePeriodMonth=${invoicePeriodMonth}&invoicePeriodYear=${invoicePeriodYear}`);
  }

  static generateMerchantInvoice(merchantCode: string, invoicePeriodMonth: string, invoicePeriodYear: string) {
    return APIClient(`/invoice/generateMerchantInvoice?merchantCode=${merchantCode}&invoicePeriodMonth=${invoicePeriodMonth}&invoicePeriodYear=${invoicePeriodYear}`);
  }

  static processAccruals(merchantCode: string, programCode: string) {
    return APIClient(`/transaction/fetchAndProcessTransactions?merchantCode=${merchantCode}&programCode=${programCode}`);
  }
} 